import { render, staticRenderFns } from "./MaterialMatchList.vue?vue&type=template&id=12af5d68&scoped=true"
import script from "./MaterialMatchList.vue?vue&type=script&lang=js"
export * from "./MaterialMatchList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12af5d68",
  null
  
)

export default component.exports